import { Typography } from '@navi/web-ui/lib/primitives';
import { useSelector } from 'react-redux';
import { RootState } from '@cp/src/store';
import { SELF_SERVE_UI_CLICKSTREAM } from '@cp/src/service/clickStream.constant';
import FileDownloadButton from '@cp/src/components/Buttons/FileDownloadButton';
import { MockAllocationDetails } from '../../../interface';

const FailureReports = (props: { allocationDetails: MockAllocationDetails }) => {
  const { allocationDetails } = props;

  const postAllocationAgencyAllocationFailureReport =
    allocationDetails?.postAllocationAgencyAllocationFailureReport;

  const postAllocationAgencyAgentAllocationFailureReport =
    allocationDetails?.postAllocationAgencyAgentAllocationFailureReport;
  const mockId = useSelector(
    (state: RootState) => state?.fieldAllocation?.fieldAllocationDetails?.allocationTrackerId || ''
  );

  if (
    !postAllocationAgencyAllocationFailureReport &&
    !postAllocationAgencyAgentAllocationFailureReport
  )
    return null;

  const attribute = {
    mockId: mockId
  };

  return (
    <div className="flex justify-between gap-3">
      <Typography variant="h4" color="var(--grayscale-2)">
        Post allocation failure report:
      </Typography>
      <>
        {postAllocationAgencyAgentAllocationFailureReport ? (
          <FileDownloadButton
            label={'Agent'}
            presignedUrl={postAllocationAgencyAgentAllocationFailureReport}
            fileName="PostAllocationAgentFailureReport"
            buttonContainer="text-center text-[--blue-base]"
            clickstreamEvent={SELF_SERVE_UI_CLICKSTREAM.LH_DOWNLOAD_POST_ALLOCATION_REPORT_CLICKED}
            attributes={attribute}
          />
        ) : null}
        {postAllocationAgencyAllocationFailureReport ? (
          <FileDownloadButton
            label={'Agency'}
            presignedUrl={postAllocationAgencyAllocationFailureReport}
            fileName="PostAllocationAgencyFailureReport"
            buttonContainer="text-center text-[--blue-base]"
            clickstreamEvent={SELF_SERVE_UI_CLICKSTREAM.LH_DOWNLOAD_POST_ALLOCATION_REPORT_CLICKED}
            attributes={attribute}
          />
        ) : null}
      </>
    </div>
  );
};

export default FailureReports;
